import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../../../shared/constants';
import { getHistoricalRecordFilters } from '../../../shared/services';
const useGetHistoricalRecordFilters = () => {
    return useQuery({
        queryKey: [QueryKeys.GetHistoricalRecordsFilters],
        queryFn: getHistoricalRecordFilters,
        select: (data) => {
            const { offices, templates, send_grid_events: events } = data.data || {};
            return {
                offices: Object.entries(offices).map(([key, value]) => ({
                    label: value,
                    value: key,
                })) || [],
                templates: Object.entries(templates).map(([key, value]) => ({
                    label: value,
                    value: key,
                })) || [],
                events: Object.entries(events).map(([key, value]) => ({
                    label: value,
                    value: key,
                })) || [],
            };
        },
    });
};
export default useGetHistoricalRecordFilters;
